// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBQUTr9uiMs1tia65SfUkWNi8t5xkJUXHU",
  authDomain: "chatbot-lapile.firebaseapp.com",
  databaseURL: "https://chatbot-lapile-default-rtdb.firebaseio.com",
  projectId: "chatbot-lapile",
  storageBucket: "chatbot-lapile.firebasestorage.app",
  messagingSenderId: "1010574424589",
  appId: "1:1010574424589:web:d6d0c36c0c1f588e073344"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);

// import { initializeApp } from "firebase/app";
// import { getDatabase } from "firebase/database";

// const firebaseConfig = {
//   apiKey: "AIzaSyBbbX3OaNNNGzuDZ9SmV0V5PcIoKNpigUc",
//   authDomain: "chatbot-tresa1.firebaseapp.com",
//   databaseURL: "https://chatbot-tresa1-default-rtdb.firebaseio.com",
//   projectId: "chatbot-tresa1",
//   storageBucket: "chatbot-tresa1.firebasestorage.app",
//   messagingSenderId: "232428500264",
//   appId: "1:232428500264:web:0275e241642aaeff07cc1d"
// };

// const app = initializeApp(firebaseConfig);

// export const db = getDatabase(app);